import * as React from 'react'
import { observer } from 'mobx-react'
import { useBrandingSettings } from 'hooks/branding'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './ArchiveBundleModal.sass'
import ArchiveBundleViewModel from './ArchiveBundleViewModel'

interface Props {
  vm: ArchiveBundleViewModel
}

export default observer(function ArchiveBundleDialog({ vm }: Props) {
  const { corporateMode } = useBrandingSettings()
  const bundleName = vm.bundle.name
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_archive-item.svg')}
              alt="Archive bundle"
            />
          )}
          <h3 className={styles.title}>You’re about to archive a bundle</h3>
          <p className={styles.description}>
            Are you sure you want to archive the{' '}
            <span className={styles.bundleName}>{bundleName}</span> bundle? All
            future jobs will no longer be able to reference this bundle.
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            disabled={vm.archive.pending}
            onClick={vm.close}
            type="default"
            dataTest="bundle-close-archive-modal"
          >
            Cancel
          </Button>
          <Button
            onClick={vm.archive}
            loading={vm.archive.pending}
            disabled={vm.archive.pending}
            type="danger"
            dataTest="bundle-modal-archive-button"
          >
            Archive
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
